import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { format, parseISO } from 'date-fns';
import { FormattedMessage } from 'react-intl';
import DefaultModal from '../../Modals/index'
import { translate } from '../../../components/Translate';
import { getImagePath } from '../../../utils';
import PurchaseModal from '../../../containers/PurchaseModal';
import 'react-awesome-slider/dist/styles.css';
import Carousel from '../../Carousel';
import { useResponsiveValue } from '@theme-ui/match-media';
import { languageDates } from '../../../utils/validations';

/**
 * @returns {undefined}
 */

const MyAccountChangePlan = ({
  history,
  plans,
  user,
  client,
  updatePlanSubscription,
  setIgnoreRedirect,
  addProduct,
  products,
  methodId,
  subscriptions,
  userPlan,
  cleanOrder,
  intl,
}) => {
  const querystring = window.location.search
  const params = new URLSearchParams(querystring)
  const language = params.get('language')

  const [modalChangePlan, setModalChangePlan] = useState(false)
  const [modalPurchase, setModalPurchase] = useState(null);
  const [isSubmitting, setSubmitting] = useState(false);

  const alertSVG = getImagePath('ic_alert.svg', client);
  const approvedSVG = getImagePath('ic_approved.svg', client);

  useEffect(() => {
    setIgnoreRedirect(true);
  }, []);
  const handleContinueClick = (product) => {
    cleanOrder();
    addProduct({ ...product });
    history.push(`/${client}/subscribe/my-payment-methods${history.location.search}`)
  }

  const changePlanHandler = async productID => {
    setSubmitting(true);
    const { status } = await updatePlanSubscription({ newPlan: productID, token: user.token, subscriptions, products, methodId });
    setSubmitting(false);
    setModalPurchase({
      code: status,
      img: status <= 300 ? approvedSVG : alertSVG,
      default: status <= 300 ? 'default' : 'error',
      handleClick: () => {
        setModalPurchase(false)
        if (status <= 300) {
          history.goBack()
        }
      },
      handleCloseModal: () => {
        setModalPurchase(false)
        if (status <= 300) {
          history.goBack()
        }
      }
    })
  };

  const numberOfCards = useResponsiveValue([
    2,
    2,
    plans.length > 4 ? 4 : plans.length,
  ]);

  return (
    <div className="MembershipSelectionPage">
      <div className="myaccount-title">
        <p className="h6 text-uppercase">
          <FormattedMessage
            id="MyAccount.title"
          />
        </p>
      </div>
      <div className="myaccount-title">
        <p className="h6 text-uppercase">
          <FormattedMessage
            id="MyAccount.changePlan"
          />
        </p>
      </div>
      <div
        className="MembershipPlans BuyPlans"
        style={plans.length <= 2 ? { padding: '2rem 9rem' } : {}}
      >
        <Carousel
          key={`Carousel ${numberOfCards}`}
          products={plans}
          allProducts={products}
          user={user}
          intl={intl}
          client={client}
          toggleForm={() => {}}
          carouselOptions={{
            numberOfCards,
            slidesToScroll: 1,
          }}
          onSelect={(plan) => handleContinueClick(plan)}
          userPlan={userPlan}
        />
      </div>
      <DefaultModal
        title={translate(intl, 'SubscriptionManagement.changePlan.title')}
        isOpenModal={modalChangePlan}
        onToggleModal={() => { setModalChangePlan(false) }}
        description={
          <FormattedMessage
            id="SubscriptionManagement.addExtra.body"
            values={{
              date: format(parseISO(userPlan?.expiresAt),
              languageDates.includes(language.toLowerCase()) ? 'dd/MM/yy' : 'LL/dd/yyyy')
            }}
          />
        }
        primaryButton={{
          text: translate(intl, 'SubscriptionManagement.addExtraCancel'),
          onClick: () => {
            setModalChangePlan(false)
          },
          isSubmitting
        }}
        secondaryButton={{
          text: translate(intl, 'SubscriptionManagement.addExtra'),
          onClick: () => {
            setModalChangePlan(false)
            changePlanHandler(modalChangePlan)
          },
          isSubmitting
        }}
      />
      {modalPurchase &&
        <PurchaseModal
          isOpenModal={Boolean(modalPurchase)}
          onToggleModal={modalPurchase?.handleCloseModal}
          code={modalPurchase?.code}
          image={modalPurchase?.img && (
            <img
              className="PaymentStatus__img"
              src={modalPurchase?.img}
              alt="modal payment status"
            />
          )}
          title={
            <FormattedMessage
              id={`PaymentStatus.subscription.messages.${modalPurchase?.code}.title`}
              defaultMessage={translate(intl, `PaymentStatus.subscription.messages.${modalPurchase?.default}.title`)}
            />
          }
          description={
            <FormattedMessage
              id={`PaymentStatus.subscription.messages.${modalPurchase?.code}.body`}
              defaultMessage={translate(intl, `PaymentStatus.subscription.messages.${modalPurchase?.default}.body`)}
            />
          }
          errorDescription={
            <FormattedMessage
              id="PaymentStatus.subscription.messages.default.status"
              defaultMessage={translate(intl, `PaymentStatus.subscription.buttons.${modalPurchase?.default}.submit`)}
              values={{ code: modalPurchase?.code || 'unknown' }}
            />
          }
          secondaryButton={{
            text: translate(intl, 'PaymentStatus.subscription.buttons.completed.submit'),
            onClick: () => { modalPurchase.handleClick() },
            isSubmitting
          }}
        />}
    </div>
  );
};


MyAccountChangePlan.propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func,
    push: PropTypes.func,
    location: PropTypes.shape({
      search: PropTypes.string,
    }).isRequired,
  }),
  plans: PropTypes.array,
  products: PropTypes.array,
  subscriptions: PropTypes.array,
  user: PropTypes.object,
  userPlan: PropTypes.object,
  updatePlanSubscription: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  client: PropTypes.string,
  methodId: PropTypes.string,
  setIgnoreRedirect: PropTypes.func.isRequired,
  addProduct: PropTypes.func.isRequired,
  cleanOrder: PropTypes.func.isRequired,
};

export default MyAccountChangePlan;
